import React from 'react';
import { API } from 'aws-amplify';

import { basicReducer as reducer } from '../../../../../utils/reducers';
import { toast } from 'react-toastify';

import useStyles from './styles';

const initState = {
    isDoingAjax: false,
    newStatus: '',
    changeReason: '',
    error: true,
    showError: false,
};

const useStatusChange = () => {
    const [state, dispatch] = React.useReducer(reducer, initState);
    const styles = useStyles();

    const handleStatusChange = (_newStatus) => {
        dispatch({
            type: 'update',
            newState: {
                newStatus: _newStatus,
                error: false,
            },
        });
    };

    const handleSaveClick = async (close, statementId) => {
        if (state?.error) {
            toast.error('A status is required.');
            dispatch({
                type: 'update',
                newState: {
                    showError: true,
                },
            });
            return;
        }

        dispatch({
            type: 'doingAjax',
        });

        var toastId = toast.loading('Updating annual statement status.');
        try {
            let response = await API.post('ShipyardAPI', '/finances/annual_statement/status', {
                body: {
                    statementId,
                    statusId: state?.newStatus,
                },
            });

            toast.success(response?.message || 'Success.');
            close?.(true);

            _resetModal?.();
        } catch (e) {
            toast.error('API error.');
            console.error(e);

            dispatch({
                type: 'ajaxDone',
            });
        } finally {
            toast.dismiss(toastId);
        }
    };

    const handleCloseClick = (close) => {
        close?.();
        _resetModal?.();
    };

    const _resetModal = () =>
        dispatch({
            type: 'update',
            newState: initState,
        });

    return {
        ...state,
        handleStatusChange,
        handleSaveClick,
        handleCloseClick,
        styles,
    };
};

export default useStatusChange;
